import { BlockState } from "./types"

//you can enter clear, goal and start
//you can not enter filled.
export const  canEnter =(grid: number[][], x:number, y:number)=>{
    return grid[y][x] !== BlockState.Filled;
}

export const  success =(grid: number[][], x:number, y:number)=>{
    return grid[y][x] === BlockState.Goal;
}


export const isStringInArrayWithKey =(key:string,target:string)=>{
  return valueAsArray(key).includes(target);
}

export const getRandomNumberBetween =(min: number, max:number) =>{
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const pickFrom=(array: any[])=>{
  return array[getRandomNumberBetween(0, array.length -1)];
}

export const addStringToArrayWithKey =(key:string,target:string)=>{
  const tmp = valueAsArray(key);
  tmp.push(target);
  localStorage[key] = JSON.stringify(tmp);
}

export const addNumToArrayWithKey =(key:string,target:number)=>{
  const tmp = valueAsArray(key);
  tmp.push(target);
  localStorage[key] = JSON.stringify(tmp);
}

export const initEmptyArrayAtKey =(key:string)=>{
  const tmp:any[] = [];
  localStorage[key] = JSON.stringify(tmp);
  return tmp;
}

export const valueAsArray = (key: string)=>{
  if(localStorage[key]){
    return JSON.parse(localStorage[key]) as any[];
  }else{
    return initEmptyArrayAtKey(key);
  }
}